import spec from '../api/openapi.gen.json' with { type: 'json' };

const { maxLength, minLength, pattern } = spec.components.schemas.Nickname;
const notBlank = new RegExp(pattern, 'u');

const breachOf = (nickname: string): string => {
  const length = [...nickname].length;
  if (length < minLength) return `A nickname has at least ${minLength} characters`;
  if (length > maxLength) return `A nickname has at most ${maxLength} characters`;
  if (!notBlank.test(nickname)) return 'A nickname needs more than spaces';
  return '';
};

export const meetsNicknameRule = (nickname: string | undefined): boolean => !breachOf(nickname ?? '');

export const whyNicknameRefused = (nickname: string | undefined): string => (nickname ? breachOf(nickname) : '');
